import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { UsersService } from '../../../shared/services/users.service';
import { CreateUserRequest } from '../../../shared/types/user.types';
import {
  UserFormComponent,
  UserFormPayload,
} from '../user-form/user-form.component';

@Component({
  selector: 'app-user-create',
  imports: [CommonModule, RouterModule, UserFormComponent, PageHeaderComponent],
  templateUrl: './user-create.component.html',
})
export class UserCreateComponent {
  private readonly usersService = inject(UsersService);
  private readonly router = inject(Router);

  readonly submitting = signal(false);
  readonly serverError = signal<string | null>(null);

  onSave(payload: UserFormPayload): void {
    this.submitting.set(true);
    this.serverError.set(null);

    this.usersService.create(payload as CreateUserRequest).subscribe({
      next: (created) => {
        this.submitting.set(false);
        void this.router.navigate(['/users', created.id]);
      },
      error: (err: unknown) => {
        this.submitting.set(false);
        this.serverError.set(
          toErrorMessage(err, 'La création a échoué.', {
            409: 'Identifiant, email ou téléphone déjà utilisé.',
          }),
        );
      },
    });
  }

  onCancel(): void {
    void this.router.navigate(['/users']);
  }
}
